export interface ResponseMapper
{
    setResponseMap(responseMap: any): void;
    setStatusMsg(message: string): void;
    setRespTime(respTime: string): void;
    setStatusCode(statusCode: String): void;
    setStatusCodeOutside(statusCodeOutside: string): void;

    getResponseMap(): any;
    getStatusMsg(): string;
    getRespTime(): string;
    getStatusCodeOutside(): string;
    getStatusCode(): string;
}
export class ResponseMapperImpl implements ResponseMapper
{
    private responseMap: any;
    private statusCodeOutside: string;
    private message: string;
    private respTime: string;
    private statusCode: string;

    setResponseMap(responseMap: any): void
    {
        //this.responseMap = JSON.stringify(responseMap);
        this.responseMap = responseMap;
    }
    getResponseMap(): any
    {
       return this.responseMap;
    }

    setStatusCodeOutside(statusCodeOutside: string)
    {
        this.statusCodeOutside = statusCodeOutside;
    }

    getStatusCodeOutside(): string {
       return this.statusCodeOutside;
    }

    setStatusMsg(message: string)
    {
        this.message = message;
    }
    getStatusMsg(): string
    {
        return this.message;
    }

    setRespTime(respTime: string)
    {
        this.respTime = respTime;
    }
    getRespTime(): string
    {
        return this.respTime;
    }

    setStatusCode(statusCode: string)
    {
        this.statusCode = statusCode;
    }
    getStatusCode(): string 
    {
       return this.statusCode;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/httpclient/response/responsemapper.tsx